<template>
	<div>
		<div class="personal-screen bg-fff">
			<div class="flex align-c screen-search">
				<div class="flex bg-fff screen-fff align-c">
					<div class="flex align-c justify-sb screen-city">
						<div class="f18 lin-25 col-333">厦门</div>
						<el-image class="screen-down"
							:src="require('@/assets/images/personal/drop-down@2x.png')"></el-image>
					</div>
					<div class="screen-input">
						<el-input v-model="keyword" placeholder="搜索职位、公司"></el-input>
					</div>
				</div>
				<div class="screen-btn flex align-c justify-c col-fff bold">
					搜索
				</div>
			</div>
			<div class="flex align-c personal-expect f16 lin-22">
				<div class="col-333 mr-26 bold">期望</div>
				<div class="bold col-169">产品经理(厦门)</div>
				<div class="mlr-16">|</div>
				<div class="flex align-c">
					<el-image class="expect-icon"
						:src="require('@/assets/images/personal/increase@2x.png')"></el-image>
					<div class="col-333">添加求职期望</div>
				</div>
			</div>
			<div class="city-title f16 lin-22 bold col-333">
				城市区域
			</div>
			<div class="flex align-c city-list mt-20 flex-wrap">
				<div class="city-item f14 lin-20 col-333 flex align-c justify-c" v-for="(item,index) in cityList" :key="index">{{item.name}}</div>
			</div>
			<div class="flex align-c mt-20 justify-sb">
				<div class="flex align-c">
					<div class="classify-menu flex align-c justify-c">
						<el-dropdown>
						  <span class="el-dropdown-link col-333">
						    工作经验<i class="el-icon-arrow-down el-icon--right"></i>
						  </span>
						  <el-dropdown-menu slot="dropdown">
						    <el-dropdown-item>不限</el-dropdown-item>
						    <el-dropdown-item>在校生</el-dropdown-item>
						    <el-dropdown-item>应届生</el-dropdown-item>
						  </el-dropdown-menu>
						</el-dropdown>
					</div>
					<div class="classify-menu flex align-c justify-c">
						<el-dropdown>
						  <span class="el-dropdown-link col-333">
						    薪资待遇<i class="el-icon-arrow-down el-icon--right"></i>
						  </span>
						  <el-dropdown-menu slot="dropdown">
						    <el-dropdown-item>不限</el-dropdown-item>
						    <el-dropdown-item>3k</el-dropdown-item>
						    <el-dropdown-item>6k</el-dropdown-item>
						  </el-dropdown-menu>
						</el-dropdown>
					</div>
					<div class="classify-menu flex align-c justify-c">
						<el-dropdown>
						  <span class="el-dropdown-link col-333">
						    学历要求<i class="el-icon-arrow-down el-icon--right"></i>
						  </span>
						  <el-dropdown-menu slot="dropdown">
						    <el-dropdown-item>不限</el-dropdown-item>
						    <el-dropdown-item>大专</el-dropdown-item>
						    <el-dropdown-item>本科</el-dropdown-item>
						  </el-dropdown-menu>
						</el-dropdown>
					</div>
					<div class="classify-menu flex align-c justify-c">
						<el-dropdown>
						  <span class="el-dropdown-link col-333">
						    公司规模<i class="el-icon-arrow-down el-icon--right"></i>
						  </span>
						  <el-dropdown-menu slot="dropdown">
						    <el-dropdown-item>不限</el-dropdown-item>
						    <el-dropdown-item>0-20人</el-dropdown-item>
						    <el-dropdown-item>20-50人</el-dropdown-item>
						  </el-dropdown-menu>
						</el-dropdown>
					</div>
					<div class="classify-menu flex align-c justify-c">
						<el-dropdown>
						  <span class="el-dropdown-link col-333">
						    公司行业<i class="el-icon-arrow-down el-icon--right"></i>
						  </span>
						  <el-dropdown-menu slot="dropdown">
						    <el-dropdown-item>不限</el-dropdown-item>
						    <el-dropdown-item>IT</el-dropdown-item>
						    <el-dropdown-item>电商</el-dropdown-item>
						  </el-dropdown-menu>
						</el-dropdown>
					</div>
				</div>
				<div class="f14 col-999 lin-20">清空筛选条件</div>
			</div>
		</div>
		<div class="mt-20 personal-post bg-fff flex align-c">
			<div class="post-item flex align-c justify-c f18 lin-25 bold" v-for="(item,index) in postList" :key="index" @click="postChange(item,index)" :class="postIndex == index ? 'col-169' : 'col-333'">
				{{item.name}}
				<div class="post-line" v-if="postIndex == index"></div>
			</div>
		</div>
		<div class="skill-label bg-fff mt-20">
			<div class="skill-label-head flex align-c justify-sb">
				<div class="f16 col-333 bold lin-22">技能认证标签</div>
				<div class="flex align-c">
					<div class="f14 lin-20 col-597">认证更多</div>
					<el-image class="skill-label-right"
						:src="require('@/assets/images/course/drop-down@2x.png')"></el-image>
				</div>
			</div>
			<div class="skill-label-c flex align-c flex-wrap">
				<div class="skill-label-i flex align-c justify-c f16 col-333 lin-22" v-for="(item,index) in skillList" :key="index">
					{{item.name}}
				</div>
			</div>
		</div>
		<div class="mt-20 skill-label bg-fff">
			<div class="skill-label-head flex align-c justify-sb">
				<div class="f16 col-333 bold lin-22">课程学习记录</div>
				<div class="flex align-c">
					<div class="f14 lin-20 col-597">认证更多</div>
					<el-image class="skill-label-right"
						:src="require('@/assets/images/course/drop-down@2x.png')"></el-image>
				</div>
			</div>
			<div class="learn-list">
				<div v-for="(item,index) in learnList" :key="index" class="learn-item f16 lin-22">
					<el-row>
						<el-col :span="13" class="bold col-333">
							{{item.name}}
						</el-col>
						<el-col :span="4" class="col-333">
							{{item.plan}}
						</el-col>
						<el-col :span="4" class="col-333">
							{{item.schedule}}%
						</el-col>
						<el-col :span="3" class="bold col-169">
							继续观看
						</el-col>
					</el-row>
				</div>
			</div>
		</div>
		<div class="recruits-item bg-fff" v-for="(item,index) in 10" :key="index">
			<div class="recruits-body">
				<div class="recruits-hit flex align-c f14 col-fff">技能考核后可投！</div>
				<el-row>
					<el-col :span="13">
						<div class="f18 col-333 bold lin-25">产品企划经理</div>
						<div class="flex align-c mt-8">
							<div class="f16 lin-22 bold recruits-price">14-20K·14薪</div>
							<div class="recruits-l flex align-c justify-c f14 col-333">3-5年</div>
							<div class="recruits-l flex align-c justify-c f14 col-333">大专</div>
							<div class="recruits-btn flex align-c justify-c f14 col-fff">简历投递</div>
						</div>
					</el-col>
					<el-col :span="11">
						<div class="flex align-c">
							<el-image class="recruits-logo"
								:src="require('@/assets/images/index/hxek.png')"></el-image>
							<div>
								<div class="f16 col-333 lin-22 bold">鸿星尔克</div>
								<div class="flex align-c mt-12">
									<div class="recruits-l flex align-c justify-c f14 col-333">电子/半导体</div>
									<div class="recruits-l flex align-c justify-c f14 col-333">A轮</div>
									<div class="recruits-l flex align-c justify-c f14 col-333">20-99人</div>
								</div>
							</div>
						</div>
					</el-col>
				</el-row>
			</div>
			<div class="recruits-footer">
				<el-row>
					<el-col :span="13">
						<div class="flex align-c recruits-footer-item f12 lin-16 col-666">
							移动产品经理&nbsp;&nbsp;|&nbsp;&nbsp;高级产品经理&nbsp;&nbsp;|&nbsp;&nbsp;AI产品经理
						</div>
					</el-col>
					<el-col :span="11">
						<div class="flex align-c recruits-footer-item f12 lin-16 col-666">
							五险一金、交通补助、零食下午茶、带薪年假
						</div>
					</el-col>
				</el-row>
			</div>
		</div>
		<div class="personal-page">
			<el-pagination
			  background
			  layout="prev, pager, next"
			  :total="1000">
			</el-pagination>
		</div>
	</div>
</template>

<script>
	export default{
		data(){
			return{
				keyword:'',
				cityList:[
					{name:'不限'},{name:'海沧区'},{name:'湖里区'},{name:'集美区'},{name:'思明区'},{name:'同安区'},{name:'翔安区'}
				],
				postList:[{name:'精选职位'},{name:'最新职位'}],
				postIndex:0,
				skillList:[
					{name:'市场调研-运用自如'},{name:'产品规划-渐入佳境'},{name:'G端产品-渐入佳境'},
					{name:'B端产品-运用自如'},{name:'C端产品-初露锋芒'},{name:'市场调研-运用自如'},
				],
				learnList:[
					{name:'电子商户在线营销职业技能证书',plan:'第一部分',schedule:'25'},
					{name:'G端产品职业技能证书',plan:'第三部分',schedule:'30'},
					{name:'Java职业技能证书',plan:'第六部分',schedule:'70'},
					{name:'电子商户在线营销职业技能证书',plan:'第五部分',schedule:'90'},
					{name:'电子商户在线营销职业技能证书',plan:'第八部分',schedule:'10'}
				],
				
			}
		},
		mounted() {
			
		},
		methods:{
			postChange(item,index){
				this.postIndex = index
			}
		}
	}
</script>

<style>
	.personal-screen{
		padding: 28px 26px;
		border-radius: 12px;
	}
	.screen-search{
		height: 54px;
		background: #169BD5;
		border-radius: 12px;
		overflow: hidden;
		padding-left: 2px;
	}
	.screen-btn{
		width: 100px;
		height: 54px;
		font-size: 24px;
		line-height: 33px;
	}
	.screen-fff{
		width: calc(100% - 100px);
		height: 48px;
		border-radius: 10px;
	}
	.screen-city{
		width: 136px;
		border-right: 1px solid rgba(22, 155, 213, .3);
		height: 36px;
		padding: 0 12px;
	}
	.screen-down{
		width: 8px;
		height: 6px;
	}
	.screen-input{
		width: calc(100% - 136px);
		height: 48px;
		padding:0 12px ;
	}
	.screen-input .el-input__inner{
		height: 48px;
		border-radius: 12px;
		font-size: 18px;
		border: none;
		padding: 0;
	}
	.personal-expect{
		margin-top: 18px;
	}
	.mlr-16{
		margin: 0 16px;
		color: #E0E0E0;
	}
	.mr-26{
		margin-right: 26px;
	}
	.expect-icon{
		width: 16px;
		height: 16px;
		margin-right: 8px;
	}
	.city-title{
		margin-top: 24px;
	}
	.city-list{
		background: #F8F8F8;
		border-radius: 8px;
		padding-left: 12px;
	}
	.city-item{
		margin-right: 22px;
		height: 40px;
	}
	.select-items{
		padding: 0 10px;
		height: 34px;
		background: #F8F8F8;
		border-radius: 8px;
		width: 100px;
		margin-right: 10px;
	}
	.select-items .screen-down{
		margin-left: 7px;
	}
	.classify-menu{
		padding: 0 10px;
		height: 34px;
		border-radius: 8px;
		background: #F8F8F8;
		margin-right: 16px;
	}
	.classify-menu .el-dropdown-link{
		font-size: 16px;
	}
	.col-999{
		color:#999;
	}
	.personal-post{
		height: 52px;
		border-radius: 12px;
		padding: 0 26px;
	}
	.post-item{
		position: relative;
		height: 52px;
		margin-right: 36px;
		cursor: pointer;
	}
	.post-item:hover{
		color: #169BD5;
	}
	.post-line{
		width: 28px;
		height: 3px;
		background: #169BD5;
		border-radius: 2px;
		position: absolute;
		left: 0;
		right: 0;
		bottom: 0;
		margin: auto;
	}
	.skill-label{
		overflow: hidden;
		border-radius: 12px;
	}
	.skill-label-head{
		height: 48px;
		background: #F6FBFA;
		padding: 0 26px;
	}
	.col-597{
		color: #597670;
	}
	.skill-label-right{
		width: 6px;
		height: 8px;
		margin-left: 12px;
	}
	.skill-label-c{
		padding: 0 26px 22px 26px;
	}
	.skill-label-i{
		margin: 16px 16px 0 0;
		height: 34px;
		background: #F8F8F8;
		border-radius: 8px;
		padding: 0 10px;
	}
	.learn-list{
		padding: 26px 26px 0 26px;
	}
	.learn-item{
		margin-bottom: 28px;
	}
	.personal-page{
		padding: 38px 0 ;
	}
	.personal-page .el-pagination{
		padding: 0;
		display: flex;
		justify-content: center;
	}
	.personal-page .el-pagination.is-background .el-pager li,
	.personal-page .el-pagination.is-background .btn-prev,
	.personal-page .el-pagination.is-background .btn-next
	{
		background: #fff;
	}
	.recruits-item{
		margin-top: 16px;
		height: 144px;
		border-radius: 12px;
		overflow: hidden;
		position: relative;
	}
	.recruits-footer{
		height: 48px;
		background: linear-gradient(270deg, #F9F9F8 0%, #F5FCFC 100%);
		padding: 0 20px;
	}
	.recruits-body{
		height: 96px;
		padding: 20px 20px 0 20px;
	}
	.recruits-hit{
		position: absolute;
		top: 0;
		right: 0;
		width: 150px;
		height: 25px;
		background-image: url('../../../assets/images/personal/di@2x.png');
		background-position: 0 0;
		background-size: 100% 100%;
		padding-left: 18px;
	}
	.mt-8{
		margin-top: 8px;
	}
	.recruits-price{
		color: #FE574A;
		margin-right: 30px;
	}
	.recruits-l{
		height: 26px;
		background: #F8F8F8;
		border-radius: 2px;
		padding: 0 14px;
		margin-right: 10px;
	}
	.recruits-btn{
		height: 26px;
		background: #169BD5;
		border-radius: 2px;
		width: 90px;
	}
	.recruits-footer-item{
		height: 48px;
	}
	.recruits-logo{
		width: 60px;
		height: 60px;
		margin-right: 10px;
	}
	.mt-12{
		margin-top: 12px;
	}
</style>